/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Table,
  AutoComplete,
  InputGroup,
  FlexboxGrid,
  Whisper,
  Popover,
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';

import { toast } from 'react-toastify';
import { format, parseISO } from 'date-fns';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { Container } from '~/styles/tabela1';
import api from '~/services/api';

import useSearchNames from '~/services/useSearchNames';
import GraficoRecharts from './GraficoRecharts';
import PageHeader from '../../../components/PageHeader';

const { HeaderCell, Column, Cell } = Table;

function PedidosCancelados() {
  const [estabelecimentoSelecionado, setEstabelecimentoSelecionado] =
    useState('');
  const [pagina, setPagina] = useState(1);
  const [carregando, setCarregando] = useState(false);
  const [nomesEstabelecimentos, setNomesEstabelecimentos] = useState([]);
  const [pedidos, setPedidos] = useState([]);
  const [orderBy, setOrderBy] = useState('order by created_at desc');

  const buscarNomesEstabelecimentos = useSearchNames(
    setNomesEstabelecimentos,
    'estabelecimentos'
  );

  const buscarPedidos = useCallback(async () => {
    setCarregando(true);
    try {
      const resposta = await api.get('/motivo-cancelamento', {
        params: {
          pagina,
          id_estabelecimento: estabelecimentoSelecionado,
          orderBy,
        },
      });
      const lista = resposta.data.lista.map((motivos) => ({
        ...motivos,
        created_at: format(parseISO(motivos.created_at), 'dd/MM/yyyy'),
        numero_pedido: motivos.pedido.numero_pedido,
        nome_fantasia: motivos.estabelecimento.nome_fantasia,
        horario: format(parseISO(motivos.created_at), 'HH:mm'),
      }));
      setPedidos({
        lista,
        quantidade: resposta.data.quantidade,
      });
      if (pedidos.quantidade > 0 && pedidos.lista.length === 0) setPagina(1)
    } catch (e) {
      toast.error(e.message);
    }
    setCarregando(false);
  }, [pagina, estabelecimentoSelecionado, orderBy, pedidos.quantidade]);

  useEffect(() => {
    buscarPedidos();
  }, [buscarPedidos]);

  const MotivoCell = ({ rowData, dataKey, ...props }) => {
    const speaker = (
      <Popover title="Motivo:">
        <p>{`${rowData.outro_motivo ? rowData.obs : rowData.descricao}`} </p>
      </Popover>
    );

    return (
      <Cell {...props}>
        <Whisper placement="left" speaker={speaker}>
          <a href style={{ textDecoration: 'none' }}>
            {rowData[dataKey].toLocaleString()}
          </a>
        </Whisper>
      </Cell>
    );
  };

  return (
    <Container>
      <PageHeader
        title="Pedidos Cancelados"
        subtitle="Relatório de Pedidos Cancelados"
      />
      <div
        style={{
          display: 'flex',
          margin: '10px',
        }}
      >
        <div style={{ width: '50%' }}>
          <FlexboxGrid justify="start">
            <InputGroup style={{ width: '300px' }}>
              <AutoComplete
                placeholder="Pesquisar"
                width={200}
                data={nomesEstabelecimentos.map((p) => ({
                  id: p.id,
                  label: p.nome_fantasia,
                  value: p.nome_fantasia,
                }))}
                onSelect={async (value, item) => {
                  setTimeout(() => {
                    setEstabelecimentoSelecionado(item.id);
                  }, 1000);
                }}
                onChange={(value) => {
                  if (value !== '') {
                    buscarNomesEstabelecimentos(value);
                  } else {
                    setEstabelecimentoSelecionado('');
                  }
                }}
              />
              <InputGroup.Button>
                <SearchIcon />
              </InputGroup.Button>
            </InputGroup>
          </FlexboxGrid>
        </div>
        <div
          style={{
            display: 'block',
            float: 'right',
            width: '80%',
            margin: 'auto',
            marginTop: '-100px',
            marginLeft: '-100px',
          }}
        >
          <GraficoRecharts id_estabelecimento={estabelecimentoSelecionado} />
        </div>
      </div>
      <FlexboxGrid style={{ width: '100%' }}>
        <TablePagination
          carregando={carregando}
          dados={pedidos.lista}
          onChangePage={setPagina}
          quantidade={pedidos.quantidade}
          setOrderBy={setOrderBy}
        >
          <Column resizable sortable width={200}>
            <HeaderCell>Número do
              <TableHeaderTooltip label="Pedido" tooltip="Pedido" />
            </HeaderCell>
            <Cell dataKey="numero_pedido" />
          </Column>
          <Column resizable sortable width={200}>
            <HeaderCell>
              <TableHeaderTooltip label="Estabelecimento" tooltip="Estabelecimento" />
            </HeaderCell>
            <Cell dataKey="nome_fantasia" />
          </Column>
          <Column resizable sortable width={200}>
            <HeaderCell>
              <TableHeaderTooltip label="Data do Cancelamento" tooltip="Data do Cancelamento" />
            </HeaderCell>
            <Cell dataKey="created_at" />
          </Column>
          <Column resizable width={200}>
            <HeaderCell>
              <TableHeaderTooltip label="Horário do Cancelamento" tooltip="Horário do Cancelamento" />
            </HeaderCell>
            <Cell dataKey="horario" />
          </Column>
          <Column resizable sortable width={200}>
            <HeaderCell>
              <TableHeaderTooltip label="Motivo do Cancelamento" tooltip="Motivo do Cancelamento" />
            </HeaderCell>
            <MotivoCell dataKey="descricao" />
          </Column>
        </TablePagination>
      </FlexboxGrid>
    </Container>
  );
}

PedidosCancelados.propTypes = {
  rowData: PropTypes.func,
  dataKey: PropTypes.string.isRequired,
};

PedidosCancelados.defaultProps = {
  rowData: {},
};

export default PedidosCancelados;
